import React, { useCallback, useState } from "react";
import * as Yup from "yup";
import { ProfilePicture, MembersInfoEdit } from "../../contents/htmlContent";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import Webcam from "react-webcam";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import addCross from "../../assets/images/addCross.svg";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { ComonIcons } from "../../contents/commonIcons";
import editIcon from "../../assets/images/edit.svg";
import { useDispatch, useSelector } from "react-redux";
import { setMemberData } from "../../redux/actions/members/memberAction";
import { setMembershipCardsScannerPopupOpen } from "../../redux/actions/membershipCard/membershipCardAction";
import {
  ReplaceGymMemberMembershipCard,
  deleteMembershipCard,
  freezeMembershipCard,
  getGymFeatures,
  unfreezeMembershipCard,
} from "../../redux/actions/api/apiAction";
import { setRFIDCardIdValue } from "../../redux/actions/membershipCard/membershipCardAction";
import { ConfirmationModal } from "../modals/confirmationModal";
import { SaleProductCard } from "./saleProductCard";
import CollapsibleSection from "./collapsibalesections";
import ReactSelect from "react-select";
import MedicalHistorySection from "./medicalHistorySection";
import InsuranceSection from "./insuranceSection";
import MembershipCardSection from "./membershipCardSection";
import { getDefaultPhoneCountry, isValidPhoneInput } from "../../utils/phone";

const phoneFieldError = (errors, extra) =>
  (errors && errors.phone) || (extra && extra.phone);

const phoneErrorClass = (errors, extra) =>
  phoneFieldError(errors, extra) ? "is-invalid" : "";

const phoneErrorMessage = (errors, extra) => {
  const message = phoneFieldError(errors, extra);
  return message ? (
    <div className="invalid-feedback d-block">{`${message}`}</div>
  ) : null;
};

const formSchema = Yup.object().shape({
  name: Yup.string().required("Gym name is required"),
  // phone: Yup.number().required("Phone is required"),
  // email: Yup.string()
  //   .email("Please enter valid Username i.e email")
  //   .required("Username is required"),
  // gender: Yup.string().required('Gender is required'),
  activeStatus: Yup.string().required("Status is required"),
});
const DropZone = ({ values, setFieldValue, errors }) => {
  const maxSize = 10485760;
  const onDrop = useCallback((acceptedFiles) => {
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            try {
              let data = {
                fileName: acceptedFiles[0].name,
                source: uri,
                folder: "profile",
              };
              var url = await api(`file`, data, "post");
              if (url && url.data && url.data.status === 201) {
                setFieldValue("image", url.data.data);
              } else {
                toastr.error("Failed to upload image, please try again.");
              }
            } catch (err) {
              toastr.error("Failed to upload image, please try again.");
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0">Upload Picture </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    background: "#F5F7F8 !important",
    padding: 0,
    height: "auto",
    width: "100%",
    border: "none",
    boxShadow: "none",
    "&:hover": {
      border: "none",
      boxShadow: "none",
    },
  }),
};

const WebcamComponent = () => <Webcam />;

export const FormFirstStep = (formikProps) => {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    edit,
    gymId,
    loggedInGym,
    setFieldTouched,
    setErrors,
    additionalInfoErrors,
    validateAdditionalInfo,
  } = formikProps;
  const { member } = useSelector((state) => state.member);
  const { gymConfig,gym } = useSelector((state) => state.gym);
  const { settings } = useSelector((state) => state.gym.gym);
  const { RFIDCardId, membershipCardsScannerAction } = useSelector(
    (state) => state.membershipCard
  );
  const { permissions } = useSelector((state) => state.permissions);
  const { features, gymFeaturesObject } = useSelector(
    (state) => state.features
  );
  const login = useSelector((state) => state.login);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showSaleProduct, setShowSaleProduct] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      setFieldValue("dob", date);
    } else {
      setFieldValue("dob", "");
    }
  };

  const { loginUser } = login;
  const allowFreezeCardAction =
    loginUser.role === "STAFF"
      ? permissions["S-MC-FREEZE"]
        ? true
        : false
      : true;
  const allowDeleteCardAction =
    loginUser.role === "STAFF"
      ? permissions["S-MC-DELETE"]
        ? true
        : false
      : true;

  const [newRFIDCardIdValue, setNewRFIDCardIdValue] = React.useState(null);
  const dispatch = useDispatch();
  React.useEffect(() => {
    // if (!window.location.pathname.includes("/gym-panel/membersinfo/edit/")) {
    //   console.log("here trigessssssssssssssssssssssssssssssss111111111")
    //   dispatch(setMemberData(undefined));
    // }
    return () => {
      dispatch(setRFIDCardIdValue(""));
    };
  }, []);

  React.useEffect(() => {
    if (!RFIDCardId) return;
    setFieldValue("RFIDCardIdField", RFIDCardId);
    if (!values.cardMembershipId) {
      setFieldValue("cardMembershipId", RFIDCardId);
    }
    if (RFIDCardId && membershipCardsScannerAction == "replace") {
      if (values.cardMembershipId == RFIDCardId) {
        toastr.error("Same Card Scanned, Please scan different card!");
        return;
      }
      setNewRFIDCardIdValue(RFIDCardId);
    } else {
      setNewRFIDCardIdValue("");
    }
  }, [RFIDCardId]);

  React.useEffect(() => {
    if (newRFIDCardIdValue) {
      setConfirmModal({
        confirmModalOpen: true,
        title: "Replace Membership Card",
        message: `Are you sure you want to replace membership card from ${values.cardMembershipId} to ${newRFIDCardIdValue}?`,
        confirmButtonText: "Replace",
        setConfirmModalOpen: () => {
          setConfirmModal({
            ...confirmModal,
            confirmModalOpen: false,
          });
        },
        confirmHandler: () => {
          // here will show pop up to confirm that the user will be sale a product

          setShowSaleProduct(true);
        },
      });
    }
  }, [newRFIDCardIdValue]);

  const webcamRef = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState(null);
  const [phoneNumber, setPhoneNumber] = React.useState(values.phone);
  const [emergenyPhoneNumber, setEmergencyPhoneNumber] = React.useState(
    values.emergencyPhone
  );

  const [takePicture, setTakePicture] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  const [relationsOpen, setRelationsOpen] = React.useState(false);
  const [toDelete, setToDelete] = React.useState(null);
  const [isEmailDisabled, setIsEmailDisabled] = React.useState(false);
  const [isPhoneDisabled, setIsPhoneDisable] = React.useState(false);
  const currentYear = moment().year();
  const maxYear = currentYear - 18;
  const maxDate = {
    year: maxYear,
    month: 1,
    day: 1,
  };
  const [confirmModal, setConfirmModal] = React.useState({
    confirmModalOpen: false,
    title: "",
    message: "",
    setConfirmModalOpen: "",
    cancelButtonText: "",
    confirmButtonText: "",
    confirmHandler: "",
  });

  const [selectedOption, setSelectedOption] = React.useState(() =>
    values.phone ? "phone" : values.email ? "email" : null
  );
  const [referalSource,setReferalList]=useState([
    { label: "Friend", value: "friend" },
    { label: "Referral", value: "referral" },
    { label: "FaceBook", value: "fb" },
    { label: "Instagram", value: "ig" },
    { label: "Google", value: "google" },
    { label: "Other", value: "other" },
  ])
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
    setFieldValue("verifyBy", event.target.id);
  };
  React.useEffect(() => {
    if (selectedOption) return;
    if (values.phone) setSelectedOption("phone");
    else if (values.email) setSelectedOption("email");
  }, [selectedOption, values.phone, values.email]);
  const [singleRelation, setSingleRelation] = React.useState({
    firstName: "",
    // name:"",
    lastName: "",
    gender: "",
    relation: "",
    dob: "",
    accountType: "secondary",
  });

  const capture = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    let data = {
      fileName: "captured",
      source: imageSrc,
      folder: "profile",
    };
    var url = await api(`file`, data, "post");
    if (url.data.status === 201) {
      setFieldValue("image", url.data.data);
    }
    setImgSrc(imageSrc);
    setTakePicture(false);
  }, [webcamRef, setImgSrc]);

  React.useEffect(() => {
    const { numberOfRelations, setNumberOfRelations } = formikProps;
    if (relationsOpen) setNumberOfRelations((prevState) => ++prevState);
    else if (numberOfRelations > 0)
      setNumberOfRelations((prevState) => --prevState);
  }, [relationsOpen]);

  React.useEffect(() => {
    if (values.phone && values.isMobileVerfied) setIsPhoneDisable(true);
    if (values.email && values.isEmailVerified) setIsEmailDisabled(true);
    if (values.dob) setSelectedDate(values.dob);
    if(loginUser.role === "TRAINER")dispatch(getGymFeatures(loginUser.trainerGym||loginUser.assignedGym));
    else dispatch(getGymFeatures(loginUser?.gym));
  }, []);

  const handleAddFamily = () => {
    const values = Object.values(singleRelation);
    let canAddFam = true;
    for (let value of values) {
      if (value.length === 0) {
        toastr.error("Please fill all family member fields");
        canAddFam = false;
        break;
      }
    }
    if (canAddFam) {
      formikProps.setRelations([...formikProps.relations, singleRelation]);
      setSingleRelation({
        firstName: "",
        lastName: "",
        gender: "",
        relation: "",
        dob: "",
        accountType: "secondary",
      });
      formikProps.setNumberOfRelations((prevState) => ++prevState);
      setRelationsOpen(false);
    }
  };
  React.useEffect(() => {
    setFieldValue("relations", formikProps.relations);
  }, [formikProps.relations]);

  React.useEffect(() => {
    setFieldValue("relations", formikProps.relations);
  }, [formikProps.relations]);
  React.useEffect(() => {
    if (typeof toDelete == "number") {
      const filteredRelations = formikProps.relations.filter(
        (rel, index) => index !== toDelete
      );
      formikProps.setRelations(filteredRelations);
    }
  }, [toDelete]);

  React.useEffect(() => {
    if (typeof validateAdditionalInfo == "function") {
      validateAdditionalInfo(values);
    }
  }, [values, touched]);

  React.useEffect(()=>{
    if(settings?.memberRegistration?.genderDefaultValue == "F"&&!values.gender)setFieldValue("gender","F")
    else if (settings?.memberRegistration?.genderDefaultValue == "M"&&!values.gender)setFieldValue("gender","M")

   if(settings?.memberRegistration?.fields?.referralSource?.referalSourceList?.length){
    const referralArray =settings?.memberRegistration?.fields?.referralSource?.referalSourceList?.map(
        (item) => ({
          label: item.charAt(0).toUpperCase() + item.slice(1),
          value: item,
        })
      ) || [];

    setReferalList(referralArray);
   }   
  },[settings])
  return (
    <>
      <div className=" bg-white card-panel">
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title="Add User"
              subtitlestyle="ctf-tx-secondary"
              subtitle="Add info about the user"
            />
          </div>
        </div>
        <div className="profile-image-block blk-padding-y border-bottom-1">
          <div className="profile-image-inner-block d-flex justify-content-center">
            <div className="profile-image-wrapper">
              {takePicture ? (
                <div className="captureimage">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                  />
                </div>
              ) : (
                <div className="profile-image">
                  <img
                    src={
                      values?.image
                        ? values?.image
                        : require("../../assets/images/no-image_user.jpg")
                    }
                    className="img-fluid img-blk"
                    alt="user"
                  />
                </div>
              )}

              <div className="profile-image-links">
                <div className="links file-input-link">
                  <div
                    className="file-input"
                    onClick={() => {
                      takePicture ? capture() : setTakePicture(true);
                    }}
                  >
                    <h6 className="upload-link mb-0">
                      {!takePicture ? ProfilePicture.takePicture : "Capture"}
                    </h6>
                  </div>
                </div>
                <div className="links file-input-link">
                  <div className="file-input">
                    <DropZone
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="links">
                  <h6
                    className="remove-link mb-0 text-uppercase"
                    onClick={async () => {
                      if (values.image) {
                        // await api(`file`, { url: values.image }, "delete");
                        setFieldValue("image", "");
                      }
                    }}
                  >
                    {ProfilePicture.removePicture}{" "}
                  </h6>
                </div>
              </div>

              {settings?.memberRegistration?.profilePictureRequired &&
              !values.image &&
              additionalInfoErrors?.image &&
              touched.image ? (
                <div
                  className="invalid-feedback"
                  style={{ marginLeft: "32%" }}
                >{`${additionalInfoErrors.image}`}</div>
              ) : null}

              {/* </div> */}
            </div>
          </div>
        </div>
        <CollapsibleSection title="Personal Information" defaultOpen={true}>
          <div className="info trainer-info">
            <Row className="g-3">
              {" "}
              {/* reduced gutter for less spacing */}
              {/* First Name */}
              <Col md={6}>
                <FormGroup className="custom-inputs mb-3">
                  <Field
                    type="text"
                    name="firstName"
                    id="name"
                    maxLength={50}
                    placeholder={MembersInfoEdit.firstname}
                    className={`form-control ${
                      errors.firstName && touched.firstName ? "is-invalid" : ""
                    }`}
                  />
                  {errors.firstName && touched.firstName && (
                    <div className="invalid-feedback">{errors.firstName}</div>
                  )}
                  <Label for="firstName">{MembersInfoEdit.firstname}</Label>
                </FormGroup>
              </Col>
              {/* Middle Name */}
              {settings?.memberRegistration?.fields?.middleName?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="text"
                      name="middleName"
                      id="middleName"
                      maxLength={50}
                      placeholder={MembersInfoEdit.middleName}
                      className={`form-control ${
                        additionalInfoErrors?.middleName && touched.middleName
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {additionalInfoErrors?.middleName && touched.middleName && (
                      <div className="invalid-feedback">
                        {additionalInfoErrors.middleName}
                      </div>
                    )}
                    <Label for="middleName">{MembersInfoEdit.middleName}</Label>
                  </FormGroup>
                </Col>
              )}
              {/* Last Name */}
              <Col md={6}>
                <FormGroup className="custom-inputs mb-3">
                  <Field
                    type="text"
                    name="lastName"
                    id="lastName"
                    maxLength={50}
                    placeholder={MembersInfoEdit.lastname}
                    className="form-control"
                  />
                  <Label for="lastName">{MembersInfoEdit.lastname}</Label>
                </FormGroup>
              </Col>
              {/* Gender */}
              <Col md={6}>
                <FormGroup className="custom-inputs mb-3">
                  <Input
                    type="select"
                    name="gender"
                    value={values.gender}
                    onChange={(e) => setFieldValue("gender", e.target.value)}
                    className={`form-control ${
                      errors.gender && touched.gender ? "is-invalid" : ""
                    }`}
                  >
                    <option value="">Gender</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                  </Input>
                  {errors.gender && touched.gender && (
                    <div className="invalid-feedback">{errors.gender}</div>
                  )}
                  <Label for="gender">Gender</Label>
                </FormGroup>
              </Col>
              {/* Date of Birth */}
              <Col md={6}>
                <FormGroup className="custom-inputs mb-3">
                  <Datetime
                    value={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    inputProps={{ placeholder: "Select/type (DD/MM/YYYY)" }}
                    closeOnSelect
                    renderYear={(props, year) => (
                      <td {...props}>{year}</td>
                    )}
                  />
                  <Label for="date">{MembersInfoEdit.date}</Label>
                </FormGroup>
              </Col>
              {/* Marital Status */}
              {settings?.memberRegistration?.fields?.maritalStatus?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <Input
                      type="select"
                      name="martialStatus"
                      value={values.martialStatus}
                      onChange={(e) =>
                        setFieldValue("martialStatus", e.target.value)
                      }
                      className="form-control"
                      placeholder={MembersInfoEdit.martialStatus}
                    >
                      <option value="">{MembersInfoEdit.martialStatus}</option>
                      <option value="S">Single</option>
                      <option value="M">Married</option>
                      {gym.type==="complex" && <option value="D">Divorced</option>}
                      {gym.type==="complex" && <option value="W">Widowed</option>}
                    </Input>
                    {additionalInfoErrors?.martialStatus &&
                      touched.martialStatus && (
                        <div className="invalid-feedback">
                          {additionalInfoErrors.martialStatus}
                        </div>
                      )}
                    <Label for="martialStatus">
                      {MembersInfoEdit.martialStatus}
                    </Label>
                  </FormGroup>
                </Col>
              )}
              {/* Home Address */}
              {settings?.memberRegistration?.fields?.homeAddress?.enabled && (
                <Col md={6}>{
                  gym?.type==="complex" ?

                  <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="text"
                      name="homeAddress"
                      id="homeAddress"
                      maxLength={50}
                      placeholder={MembersInfoEdit.homeAddress}
                      className="form-control"
                      onChange={(e) =>
                          setFieldValue("homeAddress", e.target.value)
                        }
                    />
                    {additionalInfoErrors?.homeAddress &&
                        touched.homeAddress && (
                          <div className="invalid-feedback">
                            {additionalInfoErrors.homeAddress}
                          </div>
                        )}
                    <Label for="homeAddress">
                        {MembersInfoEdit.homeAddress}
                      </Label>
                     
                  </FormGroup>
                  
                  :
                    <FormGroup className="custom-inputs mb-3">
                      <Input
                        type="select"
                        name="homeAddress"
                        value={values.homeAddress}
                        onChange={(e) =>
                          setFieldValue("homeAddress", e.target.value)
                        }
                        className="form-control"
                      >
                        <option value="">Select a Home Address</option>
                        {settings.memberRegistration.fields.homeAddress.homeAddressesArray?.map(
                          (addr) => (
                            <option key={addr} value={addr}>
                              {addr}
                            </option>
                          )
                        )}
                      </Input>
                      {additionalInfoErrors?.homeAddress &&
                        touched.homeAddress && (
                          <div className="invalid-feedback">
                            {additionalInfoErrors.homeAddress}
                          </div>
                        )}
                      <Label for="homeAddress">
                        {MembersInfoEdit.homeAddress}
                      </Label>
                    </FormGroup>
                  
                }
                  
                </Col>
              )}
              {/* Occupation */}
              {settings?.memberRegistration?.fields?.jobTitle?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="text"
                      name="occupation"
                      placeholder={MembersInfoEdit.occupation}
                      className="form-control"
                    />
                    <Label>{MembersInfoEdit.occupation}</Label>
                  </FormGroup>
                </Col>
              )}
              {/* Company Name */}
              {settings?.memberRegistration?.fields?.companyName?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="text"
                      name="companyName"
                      placeholder={MembersInfoEdit.companyName}
                      className="form-control"
                    />
                    <Label>{MembersInfoEdit.companyName}</Label>
                  </FormGroup>
                </Col>
              )}
              {/* Handedness */}
              {settings?.memberRegistration?.fields?.handedness?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <ReactSelect
                      name="handedness"
                      options={[
                        { label: "Left", value: "left" },
                        { label: "Right", value: "right" },
                        { label: "Ambidextrous", value: "ambidextrous" },
                      ]}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions
                      value={formikProps.values.handedness}
                      onChange={(e) =>
                        formikProps.setFieldValue("handedness", e)
                      }
                      classNamePrefix="react-select" // important for targeting
                                        menuPortalTarget={document.body} // ✅ This renders dropdown in body
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // make sure it's on top
                    />
                    <Label>{MembersInfoEdit.handedness}</Label>
                  </FormGroup>
                </Col>
              )}
              {/* Smoking Habits */}
              {settings?.memberRegistration?.fields?.smokingHabits?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <ReactSelect
                      name="smokingHabits"
                      options={[
                        { label: "Non-smoker", value: "nonSmoker" },
                        { label: "Smoker", value: "smoker" },
                        { label: "E-cigarette", value: "eCigaratte" },
                        { label: "Ex-smoker", value: "eXSmoker" },
                      ]}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions
                      value={formikProps.values.smokingHabits}
                      classNamePrefix="react-select" // important for targeting
                      onChange={(e) =>
                        formikProps.setFieldValue("smokingHabits", e)
                      }
                                        menuPortalTarget={document.body} // ✅ This renders dropdown in body
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // make sure it's on top
                    />
                    <Label>{MembersInfoEdit.smokingHabits}</Label>
                  </FormGroup>
                </Col>
              )}
               {settings?.memberRegistration?.fields?.childerNote?.enabled && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="text"
                      name="childerNote"
                      placeholder={MembersInfoEdit.childerNote}
                      className="form-control"
                    />
                    <Label>childern Note</Label>
                  </FormGroup>
                </Col>
              )}
              {edit && (
                <>
                  <Col md={6}>
                    <FormGroup className="custom-inputs">
                      <PhoneInput
                        international
                        defaultCountry={getDefaultPhoneCountry(gym && gym.country)}
                        // disabled={isPhoneDisabled}
                        value={phoneNumber}
                        placeholder="Phone Number"
                        // onChange={(value) => {
                        //   if (value) {
                        //     setPhoneNumber(value);
                        //     if (isValidPhoneNumber(value)){
                        //       if(isPhoneDisabled){
                        //         toastr.warning("This Phone is Verified by sumbit .Member will be logged out from app.")
                        //       }
                        //        setFieldValue("phone", value);
                        //     }
                             
                        //     // else {
                        //     //   setFieldValue("phone", "");
                        //     // }
                        //   } else setFieldValue("phone", "");
                        // }}
                        onChange={(value) => {
                          setPhoneNumber(value || "");
                          setFieldTouched && setFieldTouched("phone", true);
                          setFieldValue("phone", value || "");
                        }}
                        className={` ${phoneErrorClass(
                          errors,
                          additionalInfoErrors
                        )}`}
                      />
                      {phoneErrorMessage(errors, additionalInfoErrors)}

                      <Label>{MembersInfoEdit.phone}</Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="custom-inputs mb-md-0">
                      <Field
                        type="text"
                        name="email"
                        id="username"
                        disabled={isEmailDisabled}
                        placeholder={
                          MembersInfoEdit.email
                            ? MembersInfoEdit.email
                            : "Not Available"
                        }
                        className={`form-control 
                          "is-invalid"}`}
                      />

                      <Label> {MembersInfoEdit.email}</Label>
                    </FormGroup>
                  </Col>
                </>
              )}
              {!edit &&
                settings?.memberRegistration?.fields?.verificationBy
                  ?.enabled && (
                  <>
                    <Col md={6}>
                      <div className="radio-div-verify">
                        <div className="mt-1">
                          <label
                            className={` label-radio ${
                              values.verifyBy === "email" ? "active" : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="options"
                              id="email"
                              autoComplete="off"
                              checked={values.verifyBy === "email"}
                              onChange={(e) =>
                                setFieldValue("verifyBy", e.target.id)
                              }
                            />{" "}
                            Email
                          </label>
                          <label
                            className={` ${
                              values.verifyBy === "phone" ? "active" : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="options"
                              id="phone"
                              autoComplete="off"
                              checked={values.verifyBy === "phone"}
                              onChange={(e) =>
                                setFieldValue("verifyBy", e.target.id)
                              }
                            />{" "}
                            Phone
                          </label>
                        </div>

                        <label className="radio-div-verify-main-label">
                          Verify By
                        </label>
                      </div>
                      {/* <FormGroup className="custom-inputs mb-md-0"></FormGroup> */}
                    </Col>
                  </>
                )}
              {!edit &&
                (settings?.memberRegistration?.primaryField ==
                "emailAndPhone" ? (
                  <>
                    <Col md={6}>
                      <FormGroup className="fields-radio custom-inputs mb-md-0">
                        <Field
                          type="text"
                          name="email"
                          id="username"
                          placeholder={MembersInfoEdit.email}
                          className={`form-control ${errors.email &&
                            touched.email &&
                            "is-invalid"}`}
                        />
                        {additionalInfoErrors?.email &&
                        touched.email &&
                        touched.verifyBy ? (
                          <div className="invalid-feedback">{`${additionalInfoErrors.email}`}</div>
                        ) : null}
                        <Label> {MembersInfoEdit.email}</Label>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fields-radio custom-inputs mb-md-0">
                        <PhoneInput
                          international
                          defaultCountry={getDefaultPhoneCountry(gym && gym.country)}
                          disabled={edit && gymId !== loggedInGym}
                          value={phoneNumber}
                          // onBlur={formikProps.handleBlur}
                          placeholder="Phone Number"
                          id="phone"
                          onChange={(value) => {
                            setPhoneNumber(value || "");
                            setFieldTouched && setFieldTouched("phone", true);
                            setFieldValue("phone", value || "");
                            if (
                              value &&
                              !isValidPhoneInput(value, values.country)
                            ) {
                              setErrors &&
                                setErrors({
                                  ...errors,
                                  phone: "Phone number is not valid",
                                });
                            }
                          }}
                          className={` ${phoneErrorClass(
                            errors,
                            additionalInfoErrors
                          )}`}
                        />
                        {phoneErrorMessage(errors, additionalInfoErrors)}

                        <Label>{MembersInfoEdit.phone}</Label>
                      </FormGroup>
                    </Col>

                    {!values.email || !values.phone ? (
                      <div className="invalid-feedback ml-4">
                        Email or phone is invalid
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Col md={6}>
                      <div className="radio-div">
                        <label
                          className={` label-radio ${
                            selectedOption === "email" ? "active" : ""
                          }`}
                        >
                          <input
                            type="radio"
                            name="options"
                            id="email"
                            autoComplete="off"
                            checked={selectedOption === "email"}
                            onChange={handleOptionChange}
                          />{" "}
                          Email
                        </label>
                        <label
                          className={` ${
                            selectedOption === "phone" ? "active" : ""
                          }`}
                        >
                          <input
                            type="radio"
                            name="options"
                            id="phone"
                            autoComplete="off"
                            checked={selectedOption === "phone"}
                            onChange={handleOptionChange}
                          />{" "}
                          Phone
                        </label>
                      </div>
                      {/* <FormGroup className="custom-inputs mb-md-0"></FormGroup> */}
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fields-radio custom-inputs mb-md-0 mt-9">
                        {selectedOption === "email" && (
                          <>
                            <Field
                              type="text"
                              name="email"
                              id="username"
                              placeholder={MembersInfoEdit.email}
                              className={`form-control ${errors.email &&
                                touched.email &&
                                "is-invalid"}`}
                            />
                            {errors.email && touched.email ? (
                              <div className="invalid-feedback">{`${errors.email}`}</div>
                            ) : null}
                            <Label> {MembersInfoEdit.email}</Label>
                          </>
                        )}
                        {selectedOption == "phone" && (
                          <>
                            <PhoneInput
                              international
                              defaultCountry={getDefaultPhoneCountry(gym && gym.country)}
                              disabled={edit && gymId !== loggedInGym}
                              value={phoneNumber}
                              // onBlur={formikProps.handleBlur}
                              placeholder="Phone Number"
                              id="phone"
                             onChange={(value) => {
                              setPhoneNumber(value || "");
                              setFieldTouched && setFieldTouched("phone", true);
                              setFieldValue("phone", value || "");
                              if (
                                value &&
                                !isValidPhoneInput(value, values.country)
                              ) {
                                setErrors &&
                                  setErrors({
                                    ...errors,
                                    phone: "Phone number is not valid",
                                  });
                              }
                            }}
                              // onChange={(value) => {
                              //   if (value) {
                              //     setPhoneNumber(value);
                              //     setFieldTouched("phone", true);
                              //     if (isValidPhoneNumber(value)) {
                              //       setFieldValue("phone", value);
                              //     } // Set the 'phone' field as touched
                              //     else {
                              //       setFieldValue("phone", "");
                              //       formikProps.setErrors({
                              //         ...errors,
                              //         phone: "Phone Number is Invalid",
                              //       });
                              //     }
                              //   }
                              // }}
                              className={` ${phoneErrorClass(
                                errors,
                                additionalInfoErrors
                              )}`}
                            />
                            {phoneErrorMessage(errors, additionalInfoErrors)}

                            <Label>{MembersInfoEdit.phone}</Label>
                          </>
                        )}
                      </FormGroup>
                    </Col>

                    {!values.email && !values.phone ? (
                      <div className="invalid-feedback ml-4">
                        Email or phone is invalid
                      </div>
                    ) : null}
                  </>
                ))}
            </Row>
          </div>
        </CollapsibleSection>
        {settings?.memberRegistration?.fields?.emergencyContact?.enabled && (
          <CollapsibleSection title="Emerency Contact " defaultOpen={settings?.memberRegistration?.fields?.emergencyContact?.isRequired}>
            <Row className="pb-4 mt-4">
              <Col md={6}>
                <FormGroup className="custom-inputs ">
                  <Field
                    type="text"
                    name="emergencyName"
                    id="name"
                    maxLength={50}
                    // disabled={edit && gymId !== loggedInGym}
                    placeholder={MembersInfoEdit.emergencyName}
                    className={`form-control ${errors.emergencyName &&
                      touched.emergencyName &&
                      "is-invalid"}`}
                  />
                  {additionalInfoErrors?.emergencyName &&
                  touched.emergencyName ? (
                    <div className="invalid-feedback">{`${additionalInfoErrors.emergencyName}`}</div>
                  ) : null}
                  <Label for="emergencyName" className="">
                    {MembersInfoEdit.emergencyName}
                  </Label>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="custom-inputs">
                  <PhoneInput
                    international
                    defaultCountry={getDefaultPhoneCountry(gym && gym.country)}
                    value={emergenyPhoneNumber}
                    placeholder="Phone Number"
                    onChange={(value) => {
                      if (value) {
                        setEmergencyPhoneNumber(value);
                        if (isValidPhoneNumber(value))
                          setFieldValue("emergencyPhone", value);
                        else {
                          setFieldValue("emergencyPhone", "");
                        }
                      }
                    }}
                    className={` ${errors.emergencyPhone &&
                      touched.emergencyPhone &&
                      "is-invalid"}`}
                  />
                  {additionalInfoErrors?.emergencyPhone &&
                  touched.emergencyPhone ? (
                    <div className="invalid-feedback">{`${additionalInfoErrors.emergencyPhone}`}</div>
                  ) : null}

                  <Label>{MembersInfoEdit.phone}</Label>
                </FormGroup>
              </Col>
            </Row>
          </CollapsibleSection>
        )}
        {(settings?.memberRegistration?.fields?.medicalHistory?.enabled ||
          settings?.memberRegistration?.fields?.healthProblem?.enabled) && (
          <CollapsibleSection title="Medical History " defaultOpen={false}>
            {/* Health Problem field */}
            {settings?.memberRegistration?.fields?.healthProblem?.enabled && (
              <div className="info w-100 mt-4">
                <Col md={12} className="pl-0">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      as="textarea"
                      name="healthProblem"
                      id="healthProblem"
                      maxLength={2000}
                      placeholder="Describe health problem (status or history) for the member.."
                      className={`form-control ${additionalInfoErrors?.healthProblem &&
                        touched.healthProblem &&
                        "is-invalid"}`}
                    />
                    {additionalInfoErrors?.healthProblem &&
                    touched.healthProblem ? (
                      <div className="invalid-feedback">{`${additionalInfoErrors.healthProblem}`}</div>
                    ) : null}
                    <Label for="healthProblem" className="">
                      {MembersInfoEdit.healthProblem}
                    </Label>
                  </FormGroup>
                </Col>
              </div>
            )}
            <MedicalHistorySection
              setFieldValue={setFieldValue}
              medicalHistory={values?.medicalHistory}
            />
          </CollapsibleSection>
        )}
        {settings?.memberRegistration?.fields?.referralSource?.enabled && (
          <CollapsibleSection title="Referral Source " defaultOpen={false}>
            {" "}
            <Col md={6}>
              <FormGroup className="custom-inputs mb-3">
                <ReactSelect
                  name="referralSource"
                  options={referalSource}
                  closeMenuOnSelect={false}
                  hideSelectedOptions
                  value={formikProps.values.referralSource}
                  onChange={(e) =>
                    formikProps.setFieldValue("referralSource", e)
                  }
                  classNamePrefix="react-select" // important for targeting
                  menuPortalTarget={document.body} // ✅ This renders dropdown in body
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // make sure it's on top
                />
                <Label>{MembersInfoEdit.referralSource}</Label>
              </FormGroup>
            </Col>
            {settings?.memberRegistration?.fields?.referralSource?.enableReferralNote &&
              <Col md={6}>
                <FormGroup className="custom-inputs mb-3">
                    <Field
                      type="textarea"
                      name="referralNote"
                      id="name"
                      maxLength={50}
                      placeholder={"Referral Note"}
                      className={`form-control ${errors.referralNote &&
                        touched.referralNote &&
                        "is-invalid"}`}
                    />
                  <Label>{"Referral Note"}</Label>
                </FormGroup>
              </Col>
            }
            
          </CollapsibleSection>
        )}
        {settings?.memberRegistration?.fields?.insuranceDetails?.enabled && (
          <CollapsibleSection
            title="Insurance Details "
            defaultOpen={
              new URLSearchParams(window.location.search).get("focus") ===
              "insurance"
            }
          >
            <InsuranceSection
              setFieldValue={setFieldValue}
              insuranceDetails={values?.insuranceDetails}
            />
          </CollapsibleSection>
        )}
        {gymConfig?.gates?.enabled &&
          gymConfig?.gates?.accessBy == "RFIDCards" &&
          edit && (
            <MembershipCardSection
              values={values}
              RFIDCardId={RFIDCardId}
              allowFreezeCardAction={allowFreezeCardAction}
              allowDeleteCardAction={allowDeleteCardAction}
              dispatch={dispatch}
              setMembershipCardsScannerPopupOpen={
                setMembershipCardsScannerPopupOpen
              }
              setConfirmModal={setConfirmModal}
              confirmModal={confirmModal}
              freezeMembershipCard={freezeMembershipCard}
              unfreezeMembershipCard={unfreezeMembershipCard}
              deleteMembershipCard={deleteMembershipCard}
            />
            // <Row className="mt-2">
            //   <Col md={6} className="pl-0">
            //     <FormGroup className="custom-inputs ">
            //       <Field
            //         type="text"
            //         name="cardMembershipId"
            //         id="cardMembershipId"
            //         disabled={true}
            //         value={
            //           values.cardMembershipId
            //             ? values.cardMembershipId
            //             : RFIDCardId
            //         }
            //         className={`form-control`}
            //       />
            //       <Label for="cardMembershipId" className="">
            //         Membership Card Number
            //       </Label>
            //     </FormGroup>
            //   </Col>
            //   <Col md={6} style={{ display: "flex" }}>
            //     {values.cardMembershipId ? (
            //       <>
            //         <button
            //           type="button"
            //           style={{ padding: "15px 10px" }}
            //           className="outlined-button-custom mr-3"
            //           form="relation-form"
            //           onClick={() => {
            //             dispatch(
            //               setMembershipCardsScannerPopupOpen(true, "replace")
            //             );
            //           }}
            //         >
            //           Replace Card
            //         </button>
            //         {allowFreezeCardAction && (
            //           <button
            //             type="button"
            //             style={{ padding: "15px 10px" }}
            //             className="outlined-button-custom mr-3"
            //             form="relation-form"
            //             onClick={() => {
            //               setConfirmModal({
            //                 confirmModalOpen: true,
            //                 title: `${
            //                   values.cardMembershipStatus == "ACTIVE"
            //                     ? "Freeze"
            //                     : "Unfreeze"
            //                 } Membership Card`,
            //                 message: `Are you sure you want to ${
            //                   values.cardMembershipStatus == "ACTIVE"
            //                     ? "freeze"
            //                     : "unfreeze"
            //                 } membership card?`,
            //                 confirmButtonText:
            //                   values.cardMembershipStatus == "ACTIVE"
            //                     ? "Freeze"
            //                     : "Unfreeze",
            //                 setConfirmModalOpen: () => {
            //                   setConfirmModal({
            //                     ...confirmModal,
            //                     confirmModalOpen: false,
            //                   });
            //                 },
            //                 confirmHandler: () => {
            //                   if (values.cardMembershipStatus == "ACTIVE") {
            //                     dispatch(
            //                       freezeMembershipCard(values.cardMembershipId)
            //                     );
            //                   } else {
            //                     dispatch(
            //                       unfreezeMembershipCard(
            //                         values.cardMembershipId
            //                       )
            //                     );
            //                   }
            //                 },
            //               });
            //             }}
            //           >
            //             {values.cardMembershipStatus == "ACTIVE"
            //               ? "Freeze Card"
            //               : "Unfreeze CARD"}
            //           </button>
            //         )}
            //         {allowDeleteCardAction && (
            //           <button
            //             type="button"
            //             style={{ padding: "15px 10px" }}
            //             className="outlined-button-custom"
            //             form="relation-form"
            //             onClick={() => {
            //               setConfirmModal({
            //                 confirmModalOpen: true,
            //                 title: "Delete Membership Card",
            //                 message:
            //                   "Are you sure you want to delete membership card? This action removes it from all branches, if found",
            //                 confirmButtonText: "Delete",
            //                 setConfirmModalOpen: () => {
            //                   setConfirmModal({
            //                     ...confirmModal,
            //                     confirmModalOpen: false,
            //                   });
            //                 },
            //                 confirmHandler: () => {
            //                   dispatch(
            //                     deleteMembershipCard(values.cardMembershipId)
            //                   );
            //                 },
            //               });
            //             }}
            //           >
            //             Delete Card
            //           </button>
            //         )}
            //       </>
            //     ) : (
            //       <>
            //         <button
            //           type="button"
            //           style={{ padding: "15px 10px" }}
            //           className="outlined-button-custom"
            //           form="relation-form"
            //           onClick={() =>
            //             dispatch(
            //               setMembershipCardsScannerPopupOpen(
            //                 true,
            //                 "addCardForExistingMember"
            //               )
            //             )
            //           }
            //         >
            //           Add Card
            //         </button>
            //       </>
            //     )}
            //   </Col>
            // </Row>
          )}

        <ConfirmationModal
          setConfirmModalOpen={confirmModal.setConfirmModalOpen}
          confirmModalOpen={confirmModal.confirmModalOpen}
          title={confirmModal.title}
          message={confirmModal.message}
          confirmButtonText={confirmModal.confirmButtonText}
          confirmHandler={confirmModal.confirmHandler}
        />
        {gymConfig?.gates?.enabled &&
          gymConfig?.gates?.accessBy == "RFIDCards" &&
          !edit && (
            <MembershipCardSection
              values={values}
              RFIDCardId={RFIDCardId}
              allowFreezeCardAction={allowFreezeCardAction}
              allowDeleteCardAction={allowDeleteCardAction}
              dispatch={dispatch}
              setMembershipCardsScannerPopupOpen={
                setMembershipCardsScannerPopupOpen
              }
              setConfirmModal={setConfirmModal}
              confirmModal={confirmModal}
              freezeMembershipCard={freezeMembershipCard}
              unfreezeMembershipCard={unfreezeMembershipCard}
              deleteMembershipCard={deleteMembershipCard}
              setRFIDCardIdValue={setRFIDCardIdValue}
            />
            // <>
            //   <Col md={6}>
            //     <FormGroup className="custom-inputs mb-md-0 mt-5">
            //       <Field
            //         type="text"
            //         name="RFIDCardIdField"
            //         id="RFIDCardIdField"
            //         disabled={true}
            //         value={RFIDCardId}
            //         className={`form-control ${!RFIDCardId && "is-invalid"}`}
            //       />
            //       {!RFIDCardId ? (
            //         <div className="invalid-feedback">
            //           Membership Card is required
            //         </div>
            //       ) : null}
            //       <Label for="RFIDCardIdField" className="">
            //         Membership Card Number
            //       </Label>
            //     </FormGroup>
            //   </Col>
            //   <Col md={6} className="mt-5">
            //     {!RFIDCardId ? (
            //       <button
            //         type="button"
            //         style={{ padding: "15px 10px" }}
            //         className="outlined-button-custom"
            //         form="relation-form"
            //         onClick={() =>
            //           dispatch(setMembershipCardsScannerPopupOpen(true, "add"))
            //         }
            //       >
            //         Add Card
            //       </button>
            //     ) : (
            //       <button
            //         type="button"
            //         style={{ padding: "15px 10px" }}
            //         className="outlined-button-custom"
            //         form="relation-form"
            //         onClick={() => dispatch(setRFIDCardIdValue(""))}
            //       >
            //         Reset Card
            //       </button>
            //     )}
            //   </Col>
            // </>
          )}
        {gymConfig?.manageMembers?.enabled &&
          gymConfig?.manageMembers?.familyMembers && (
            <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y pl-2">
              <div className="info-title pb-0">
                <Title title={MembersInfoEdit.familymembership} />
              </div>
              {formikProps.relations.length > 0 && (
                <Row className="family-membership-table">
                  <div className="family-membership-table-inner-container">
                    {formikProps.relations.map((rel, idx) => {
                      return (
                        <div
                          key={rel.name}
                          className="family-membership-row-container"
                        >
                          <p>{`${rel.firstName} ${rel.lastName}`}</p>
                          <p>{moment(rel.dob).format("DD/MM/YYYY")}</p>
                          <p>{rel.gender === "F" ? "Female" : "Male"}</p>
                          <p>{rel.relation === "son" ? "Son" : rel.relation === "daughter" ? "Daughter" : "Other"}</p>
                          <span
                            className="relation-delete-btn"
                            onClick={() => {
                              setToDelete(idx);
                            }}
                            style={{
                              color: "#E4E7Eb",
                              cursor: "pointer",
                            }}
                          >
                            {ComonIcons.delete}
                          </span>
                          {/* <span
                            className="edit-relation-icon"
                            onClick={() => {
                              setSingleRelation(relations[idx]);
                              setRelationsOpen(true);
                            }}
                          >
                            <img src={editIcon} />
                          </span> */}
                        </div>
                      );
                    })}
                  </div>
              </Row>
            )}
            {relationsOpen && (
              <Row className="family-member-info-row pb-4 mt-4">
                {errors.relations ? (
                  <div
                    className="invalid-feedback pl-3"
                    style={{ display: "block" }}
                  >{`${errors.relations}`}</div>
                ) : null}
                <Col md={6} style={{ marginTop: "26px" }}>
                  <FormGroup className="custom-inputs  mb-md-0 ">
                    <Field
                      name="famFname"
                      id="famFname"
                      placeholder="Start typing"
                      className={`form-control  ${errors.user &&
                        touched.use &&
                        "is-invalid"} `}
                      style={{ color: "black", background: "#F5F7F8 " }}
                      onChange={(e) => {
                        setSingleRelation({
                          ...singleRelation,
                          firstName: e.target.value,
                        });
                      }}
                    />

                    <Label
                      for="famFname"
                      className="grey-background"
                      style={{
                        background: "#F5F7F8",
                        mixBlendMode: "normal",
                      }}
                    >
                        {MembersInfoEdit.firstname}
                      </Label>
                      {errors.user && touched.user ? (
                        <div className="invalid-feedback">{`${errors.user}`}</div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6} style={{ marginTop: "26px" }}>
                    <FormGroup className="custom-inputs  mb-md-0 ">
                      <Field
                        name="famLname"
                        id="famLname"
                        placeholder="Start typing"
                        className={`form-control  ${errors.user &&
                          touched.use &&
                          "is-invalid"} `}
                        style={{ color: "black", background: "#F5F7F8 " }}
                        onChange={(e) => {
                          setSingleRelation({
                            ...singleRelation,
                            lastName: `${e.target.value}`,
                          });
                        }}
                      />

                      <Label
                        for="famLname"
                        className="grey-background"
                        style={{
                          background: "#F5F7F8",
                          mixBlendMode: "normal",
                        }}
                      >
                        {MembersInfoEdit.lastname}
                      </Label>
                      {errors.user && touched.user ? (
                        <div className="invalid-feedback">{`${errors.user}`}</div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup
                      className="custom-inputs mb-md-0 "
                      style={{ marginTop: "26px" }}
                    >
                      <Datetime
                        // value={selectedDate}
                        onChange={(date) => {
                          if (date) {
                            setSingleRelation({
                              ...singleRelation,
                              dob: date,
                            });
                          } else {
                            setSingleRelation({
                              ...singleRelation,
                              dob: "",
                            });
                          }
                        }}
                        dateFormat="DD/MM/YYYY"
                        timeFormat={false}
                        inputProps={{ placeholder: "Select or type a date" }}
                        closeOnSelect
                        renderYear={(props, year) => (
                          <td {...props}>{year}</td>
                        )}
                      />
                      <small style={{ color: "#4D4467" }}>
                        {" "}
                        Date format is DD/MM/YYYY
                      </small>
                      {errors.relations?.dob && touched.relations?.dob ? (
                        <div className="invalid-feedback">{`${errors.dob}`}</div>
                      ) : null}
                      <Label
                        for="famdob"
                        className="grey-background"
                        style={{
                          background: "#F5F7F8",
                          mixBlendMode: "normal",
                        }}
                      >
                        {MembersInfoEdit.date}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6} style={{ marginTop: "26px" }}>
                    <FormGroup className="custom-inputs  mb-md-0">
                      <Input
                        type="select"
                        className={`form-control`}
                        name="famGender"
                        id="famGender"
                        placeholder={"Select"}
                        style={{
                          left: "0 !importnat",
                          width: "100% !important",
                          background: "#f5f7f8",
                          color: "rgb(0,0,0,0.5)",
                        }}
                        selected={singleRelation.gender}
                        onChange={(e) =>
                          setSingleRelation({
                            ...singleRelation,
                            gender: e.target.value,
                          })
                        }
                      >
                        <option value="">Gender</option>
                        <option key={"male"} value={"M"}>
                          Male
                        </option>
                        <option key={"female"} value={"F"}>
                          Female
                        </option>
                      </Input>

                      <Label
                        for="famGender"
                        className="grey-background"
                        style={{
                          background: "#F5F7F8",
                          mixBlendMode: "normal",
                        }}
                      >
                        {"Gender"}
                      </Label>
                      {errors.relations?.gender && touched.relations?.gender ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >{`${errors.gender}`}</div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6} style={{ marginTop: "26px" }}>
                    <FormGroup className="custom-inputs  mb-md-0">
                      <Input
                        type="select"
                        className={`form-control`}
                        name="famRelation"
                        id="famRelation"
                        placeholder={"Select"}
                        style={{
                          left: "0 !importnat",
                          width: "100% !important",
                          background: "#f5f7f8",
                          color: "rgb(0,0,0,0.5)",
                        }}
                        seleted={singleRelation.relation}
                        onChange={(e) =>
                          setSingleRelation({
                            ...singleRelation,
                            relation: e.target.value,
                          })
                        }
                      >
                        <option value="">Select</option>
                        <option key={"son"} value={"son"}>
                          Son
                        </option>
                        <option key={"daughter"} value={"daughter"}>
                          Daughter
                        </option>
                        <option key={"other"} value={"other"}>
                          Other
                        </option>
                      </Input>

                      <Label
                        for="famRelation"
                        className="grey-background"
                        style={{
                          background: "#F5F7F8",
                          mixBlendMode: "normal",
                        }}
                      >
                        {"Relation"}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6} style={{ marginTop: "25px" }}>
                    <div className="btn-right-container d-flex justify-content-end">
                      <button
                        type="button"
                        className="outlined-button-custom"
                        form="relation-form"
                        onClick={() => handleAddFamily()}
                      >
                        Save Member
                      </button>
                    </div>
                  </Col>
                </Row>
              )}

              {!member || !member.parent ? (
                <Row className="family-membership-container">
                  <div onClick={() => setRelationsOpen(!relationsOpen)}>
                    {!relationsOpen ? (
                      <img src={addCross} alt="add" />
                    ) : (
                      <span style={{ color: "#4D4467" }}>-</span>
                    )}
                    <span>Add family member</span>
                  </div>
                </Row>
              ) : (
                <p className="mt-3 ">{"This is a Son/Daughter Account"}</p>
              )}
            </div>
          )}

        {showSaleProduct && (
          <SaleProductCard
            showModal={showSaleProduct}
            toggle={() => setShowSaleProduct(false)}
            values={values}
            newRFIDCardIdValue={newRFIDCardIdValue}
          />
        )}
      </div>
    </>
  );
};
